import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, query, where, getDocs, doc, increment, getDoc, runTransaction } from 'firebase/firestore';

const Promo = ({ onBack }) => {
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const [message, setMessage] = useState({ text: '', type: '' });

    // User Data ကို အမြဲ Update ဖြစ်နေအောင် ယူထားမယ်
    const fetchUserData = async () => {
        if (!auth.currentUser) return;
        const userRef = doc(db, "users", auth.currentUser.uid);
        const snap = await getDoc(userRef);
        if (snap.exists()) setUserData(snap.data());
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const handleApply = async () => {
        const inputCode = inputValue.trim().toUpperCase();
        if (!inputCode || loading) return;

        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const userRef = doc(db, "users", auth.currentUser.uid);
            
            // 1. အရင်ဆုံး Promo Codes ထဲမှာ ရှာမယ်
            const promoQ = query(collection(db, "promo_codes"), where("code", "==", inputCode));
            const promoSnap = await getDocs(promoQ);

            if (!promoSnap.empty) {
                const promoDoc = promoSnap.docs[0];
                const promoData = promoDoc.data();
                const promoRef = doc(db, "promo_codes", promoDoc.id);

                // Transaction သုံးပြီး Data စစ်မယ်၊ Update လုပ်မယ်
                await runTransaction(db, async (transaction) => {
                    const userSnap = await transaction.get(userRef);
                    const freshUserData = userSnap.data();

                    if (freshUserData.usedPromos?.includes(inputCode)) {
                        throw new Error("ဤကုဒ်ကို သုံးပြီးသားဖြစ်သည်");
                    }
                    if (promoData.usedCount >= promoData.usageLimit) {
                        throw new Error("ကုဒ်သုံးစွဲသူဦးရေ ပြည့်သွားပါပြီ");
                    }

                    // Points ပေးပြီး Promo used list ထဲထည့်မယ်
                    transaction.update(userRef, {
                        points: increment(promoData.reward),
                        usedPromos: Array.isArray(freshUserData.usedPromos) 
                            ? [...freshUserData.usedPromos, inputCode] 
                            : [inputCode]
                    });
                    // Promo code ရဲ့ count ကို တိုးမယ်
                    transaction.update(promoRef, { usedCount: increment(1) });
                });

                setMessage({ text: `${promoData.reward} Points ရရှိပါပြီ! ✅`, type: 'success' });
                setInputValue('');
                fetchUserData(); // Refresh local data

            } 
            // 2. Promo မဟုတ်ရင် Referral Code လား စစ်မယ်
            else {
                const myReferralCode = auth.currentUser.uid.slice(0, 6).toUpperCase();
                if (inputCode === myReferralCode || inputCode === userData?.referralCode) {
                    throw new Error("မိမိ၏ Code ကို ပြန်သုံး၍မရပါ");
                }

                const usersRef = collection(db, "users");
                const q = query(usersRef, where("referralCode", "==", inputCode), where("canRefer", "==", true));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const inviterDoc = querySnapshot.docs[0];
                    const inviterRef = doc(db, "users", inviterDoc.id);

                    if (userData?.referredBy) {
                        throw new Error("သင် Referral သုံးပြီးသားဖြစ်သည်");
                    }

                    await runTransaction(db, async (transaction) => {
                        transaction.update(inviterRef, { points: increment(100) }); // Inviter Reward
                        transaction.update(userRef, { 
                            points: increment(50), // New User Reward
                            referredBy: inputCode 
                        });
                    });

                    setMessage({ text: 'Referral အောင်မြင်ပါသည်။ Reward ရရှိပါပြီ! 🎉', type: 'success' });
                    setInputValue('');
                    fetchUserData();
                } else {
                    throw new Error("မှားယွင်းနေသော ကုဒ်ဖြစ်ပါသည်");
                }
            }
        } catch (err) {
            setMessage({ text: err.message, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle}>
                <span className="material-icons-round" onClick={onBack} style={{ cursor: 'pointer' }}>arrow_back</span>
                <h3 style={{ marginLeft: '15px' }}>Promo & Referral</h3>
            </div>

            <div style={cardStyle}>
                <h4>Have a Code?</h4>
                <p style={{fontSize:'12px', color:'#666', marginBottom:'15px'}}>Promo သို့မဟုတ် Referral Code ရိုက်ထည့်ပါ</p>
                <input 
                    style={inputStyle} 
                    value={inputValue} 
                    onChange={(e)=>setInputValue(e.target.value)} 
                    placeholder="ENTER CODE" 
                    disabled={loading}
                />
                <button 
                    onClick={handleApply} 
                    style={{...submitBtn, opacity: loading ? 0.7 : 1}} 
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Apply Code'}
                </button>
                {message.text && (
                    <div style={{
                        marginTop: '15px', 
                        padding: '10px', 
                        borderRadius: '8px', 
                        backgroundColor: message.type === 'success' ? '#e8f5e9' : '#ffebee',
                        color: message.type === 'success' ? '#2e7d32' : '#c62828',
                        fontSize: '13px'
                    }}>
                        {message.text}
                    </div>
                )}
            </div>

            {userData?.canRefer && (
                <div style={referCard}>
                    <div style={{fontSize:'24px', marginBottom:'10px'}}>📣</div>
                    <h4>Invite & Earn</h4>
                    <p style={{fontSize:'12px', color: '#555'}}>သူငယ်ချင်းများကို ဖိတ်ခေါ်ပြီး Reward ရယူပါ</p>
                    <div style={codeDisplay}>
                        <small style={{color: '#888'}}>Your Referral Code</small>
                        <div style={{fontSize:'22px', fontWeight:'bold', color: '#1a1a1a', marginTop: '5px'}}>
                            {userData.referralCode || auth.currentUser.uid.slice(0, 6).toUpperCase()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- Styles ---
const containerStyle = { padding: '20px', background: '#f8f9fa', minHeight: '100vh' };
const headerStyle = { display: 'flex', alignItems: 'center', marginBottom: '20px' };
const cardStyle = { background: '#fff', padding: '25px', borderRadius: '20px', textAlign: 'center', boxShadow:'0 4px 15px rgba(0,0,0,0.05)' };
const inputStyle = { width: '100%', padding: '15px', borderRadius: '12px', border: '1px solid #ddd', fontSize:'16px', textAlign:'center', marginBottom:'15px', outline: 'none' };
const submitBtn = { width: '100%', padding: '15px', background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '12px', fontWeight:'bold', cursor: 'pointer' };
const referCard = { marginTop:'20px', background:'#fff', padding:'25px', borderRadius:'20px', textAlign:'center', border:'2px solid #e5b95f' };
const codeDisplay = { marginTop:'15px', padding:'15px', background:'#fffaf0', border:'1px dashed #e5b95f', borderRadius:'12px' };

export default Promo;